import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Pagination from "../Utils/Pagenation";
import { TextMediumSM } from "../Text/MediumText";
import ModalContainer from "./ModalContainer";
import MoreOptions from "../Utils/MoreOptions";
import NuDate from "../Utils/NuDate";
import NuAmount from "../Utils/NuAmount";
import { Link } from "react-router-dom";
import FileIcon from "../Icons/FileIcon";
import { GetAccess, GetRole } from "../Utils/roles";
import Date from "../Icons/Date";
import { CancelButton } from "../Utils/Buttons";
import moment from "moment";
import { DateBetween, isStepActive } from "../../utils/date";
import { OrderFlow2, OrderFlowPO, OrderFlowShipment } from "./OrderFlow";

// Table component

const DynamicTable = ({
  fetcher,
  data = [],
  headers,
  bodyHeight,
  total,
  hasMultiEdit,
  hasMultiDelete,
  listofNumbers,
  selectOne = () => { },
  selectMultiple = () => { },
  fullList,
  getById,
  DeteleAccess,
  EditAccess,
  dataLoading,
  pageIndex,
  searchQuery,
  dateShow,
  orderflow,
}) => {
  const { t, i18n } = useTranslation();

  const getAlignClass = (header) => {
    if (header?.textAlign === "left") return "text-left";
    if (header?.textAlign === "right") return "text-right";
    return "text-center";
  };

  const RenderCell = ({ header, row }) => {
    if (header && row) {
      if (header?.field === "prDesc") {
        return (
          <p
            className={`line-clamp-2 text-[11px] text-gray-700 ${getAlignClass(header)}`}
          >
            {row.prDesc || "No Description"}
          </p>
        );
      }
      if (header?.hasTwoFields) {
        return (
          <div className={getAlignClass(header)}>
            <p className="text-[12px] text-[#606279] font-medium">
              {row[header?.fieldOne] || "N/A"}
            </p>

            <p
              className={`text-[10px] font-medium italic ${row[header?.fieldTwo] === "Public"
                ? "text-green-600"
                : "text-purple-600"
                }`}
            >
              {row[header?.fieldTwo] || "N/A"}
            </p>
          </div>
        );
      }

      if (header?.field === "vendorNameOrPurchaserName") {
        const vendorName = row.vendorName;
        const purchaserName = row.purchaserName;
        const alignClass = getAlignClass(header);

        if (vendorName) {
          return (
            <p className={`text-[11px] text-red-700 ${alignClass}`}>
              {vendorName}
            </p>
          );
        } else if (purchaserName) {
          return (
            <p className={`text-[11px] text-green-700 ${alignClass}`}>
              {purchaserName}
            </p>
          );
        } else {
          return (
            <p className={`text-[11px] text-gray-400 ${alignClass}`}>No Data</p>
          );
        }
      }
      if (header?.field === "agentName") {
        return (
          <div className={getAlignClass(header)}>
            <p className="text-[12px] text-[#606279] font-medium">
              {row.agentName || "-"}
            </p>
            {row.shipmentBill && (
              <p className="text-[10px] text-gray-400 font-medium italic">
                {`(${row.shipmentBill})`}
              </p>
            )}
          </div>
        );
      }
      if (header?.isLink) {
        return (
          <Link
            to={header.link + row[header.id]}
            state={{
              data: row,
              pageIndex: pageIndex,
              searchQuery: searchQuery,
            }}
          >
            {getField(row, header?.field, header?.type, header?.textAlign)}
          </Link>
        );
      } else {
        if (header?.hasTwo === true) {
          return (
            <div>
              <p className=" text-[11px] text-green-600">
                <NuAmount value={row[header?.fieldOne] || 0} /> {` (Actual)`}
              </p>
              <p className=" text-[10px] text-gray-400">
                <NuAmount value={row[header?.fieldTwo] || 0} /> {` (Est.)`}
              </p>
            </div>
          );
        } else if (
          header?.field === "action" &&
          header?.title === "Action" &&
          header?.contents
        ) {
          return (
            <MoreOptions
              data={row}
              fetcher={fetcher}
              id={row[header.contents?.id] || ""}
              removevalue={row[header.contents?.removeValue] || "undefined"}
              url={header.contents?.url}
              moduleName={header.contents?.moduleName}
              from={header.contents?.from}
              editLink={header.contents?.editLink}
              viewLink={header.contents?.viewLink}
              curentPage={pageIndex}
              DeteleAccess={DeteleAccess}
              EditAccess={EditAccess}
              EmailRequired={header.contents?.EmailRequired}
              isEmailSent={row.isEmailSent}
              emailEnable={row.emailEnable}
              emailType={header.contents?.emailType}
              adminPermmision={header.contents?.adminPermmision}
              searchQuery={searchQuery}
            />
          );
        } else if (header?.isCondition) {
          return row[header.field] ? "Yes" : "No";
        } else {
          return getField(row, header?.field, header?.type, header?.textAlign);
        }
      }
    }
  };

  function getField(row, field, typeValue, textAlign) {
    if (field) {
      let splitValue = field.split(".");
      let value = "";
      if (splitValue.length >= 2) {
        if (splitValue.length == 3) {
          value = row[splitValue[0]][splitValue[1]][splitValue[2]];
        } else {
          value = row[splitValue[0]] ? row[splitValue[0]][splitValue[1]] : "";
        }
      } else {
        value = row[splitValue[0]];
      }

      if (typeValue === "date-time") {
        return (
          (value !== "" && value !== "None" && (
            <NuDate value={value} format="DD-MMM-YYYY hh:mm a" />
          )) ||
          ""
        );
      } else if (typeValue === "date") {
        return (
          (value !== "" && value !== "None" && (
            <NuDate value={value} format="DD-MMM-YYYY" />
          )) ||
          ""
        );
      } else if (typeValue === "time") {
        return (
          (value !== "" && value !== "None" && (
            <NuDate value={value} format="hh:mm a" />
          )) ||
          ""
        );
      } else if (typeValue === "amount") {
        return (
          (
            <NuAmount
              currency={row["vendorCurrency"] || row["currency"]}
              value={value}
            />
          ) || ""
        );
      } else if (Array.isArray(value)) {
        return value.join(", ");
      } else if (typeValue === "email") {
        const alignClass =
          textAlign === "left"
            ? "text-left"
            : textAlign === "right"
              ? "text-right"
              : "text-center";
        return (
          <p
            className={`max-w-[130px] ${alignClass} overflow-x-hidden truncate`}
          >
            {value}
          </p>
        );
      } else {
        return value;
      }
    }
  }

  function getHeaderId(row) {
    return row[getById] || 0;
  }

  const [DateNewShow, setDateNewShow] = useState(false);
  const [value, setValue] = useState([]);
  const [yprno, setYprno] = useState("");

  // const handleDateIconClick2 = (value) => {
  //   setDateNewShow(!DateNewShow);
  //   setValue(value?.tracker);
  //   setYprno(value?.ref);
  // };

  const closedate = () => {
    setValue([]);
    setYprno("");
    setDateNewShow(false);
  };

  //   const date1 = value[0]?.date;
  // const date2 = value[1]?.date;
  // const date = value[2]?.date;

  // const daysDifference = date1 && date2 ? moment(date2).diff(moment(date1), "days") : null;

  // const displayDays = daysDifference === 0 ? 1 : daysDifference;

  const dates = value.map((item) => item?.date).filter(Boolean);

  const daysDifferences = dates.map((date, index) => {
    if (index === 0) return null;
    const diff = moment(date).diff(moment(dates[index - 1]), "days");
    return diff === 0 ? 1 : diff;
  });

  return (
    <div className="w-full h-[90%] overflow-hidden">
      <div className="w-full relative max-h-[calc(100vh-145px)] overflow-y-auto">
        <div className=" w-full sticky top-0 z-30">
          <table className="w-full" dir={i18n.language == "ar" ? "rtl" : ""}>
            <thead className=" w-full">
              <tr className="text-xs   text-[#4F4768] bg-white z-10">
                {(hasMultiEdit || hasMultiDelete) && (
                  <th className="w-[0.3%] pl-2 bg-white z-10">
                    <input
                      type="checkbox"
                      onChange={(e) => selectMultiple(e)}
                      checked={
                        fullList.length > 0 &&
                        listofNumbers.length === fullList.length
                      }
                    />
                  </th>
                )}

                {headers.map((header, index) =>
                  header.mult === true ? (
                    <th
                      key={index}
                      className="py-2 px-2 truncate text-[12px] 2xl:text-sm font-medium bg-white z-50"
                      style={{
                        width: header.width,
                        textAlign: header.rowAlign || "center",
                      }}
                    >
                      <span className="w-1 h-1 bg-red-600 rounded-full inline-block "></span>{" "}
                      {t(header.title) || ""}{" "}
                      <span className="py-2 truncate text-[12px] 2xl:text-sm font-thin text-gray-700">
                        /
                      </span>
                      <span className="w-1 h-1 bg-green-600 rounded-full inline-block "></span>{" "}
                      <span className="py-2 pr-[1px] truncate text-[12px] 2xl:text-sm font-medium ">
                        {t(header.title2) || ""}
                      </span>
                    </th>
                  ) : (
                    <th
                      key={index}
                      className="py-2 px-2 truncate text-[12px] 2xl:text-sm font-medium bg-white z-50"
                      style={{
                        width: header.width,
                        textAlign: header.rowAlign || "center",
                      }}
                    >
                      {t(header.title) || ""}
                    </th>
                  ),
                )}
              </tr>
            </thead>
          </table>
          <div className="w-full h-[1px] opacity-30 bg-[#C4C2C2]  mx-auto"></div>
        </div>
        <div className={` h-auto z-10 pb-4 mb-16`}>
          <table className="w-full" dir={i18n.language == "ar" ? "rtl" : ""}>
            {dataLoading ? (
              <tbody>
                <tr>
                  <td
                    colSpan={
                      headers.length +
                      (hasMultiEdit || hasMultiDelete ? 1 : 0) +
                      (dateShow ? 1 : 0)
                    }
                  >
                    <div className=" w-full h-[50vh] flex justify-center items-center">
                      <div className=" flex flex-col justify-center items-center">
                        <div className="flex flex-row gap-2">
                          <div className="w-3 h-3 rounded-full bg-baseColor-quartary animate-bounce" />
                          <div className="w-3 h-3 rounded-full bg-baseColor-quartary animate-bounce [animation-delay:-.3s]" />
                          <div className="w-3 h-3 rounded-full bg-baseColor-quartary animate-bounce [animation-delay:-.5s]" />
                          <div className="w-3 h-3 rounded-full bg-baseColor-quartary animate-bounce [animation-delay:-.7s]" />
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            ) : data.length > 0 ? (
              data.map((row, rowIndex) => {
                const rowId = getHeaderId(row);

                return (
                  <tbody
                    key={rowId}
                    className="group bg-white text-[#606279] hover:text-baseColor-primary hover:relative hover:z-10 hover:shadow-[rgba(17,_17,_26,_0.1)_0px_0px_16px]"
                  >
                    {/* MAIN DATA ROW */}
                    <tr className="bg-white">
                      {(hasMultiEdit || hasMultiDelete) && (
                        <td className="w-[0.3%] pl-2">
                          <input
                            type="checkbox"
                            checked={listofNumbers.includes(rowId)}
                            onChange={() => selectOne(rowId)}
                          />
                        </td>
                      )}
                      {/* {dateShow && (
                        <td
                          className="w-[0.1%] cursor-pointer pb-0.5 pl-2 "
                          onClick={() => handleDateIconClick(row)}
                        >
                          <Date />
                        </td>
                      )} */}
                      {headers.map((header, colIndex) => (
                        <td
                          key={colIndex}
                          className="py-3 px-2 text-xs"
                          style={{
                            width: header.width,
                            textAlign: header.textAlign || "center",
                          }}
                        >
                          <div
                            className={`w-full flex ${header.textAlign === "left"
                              ? "justify-start"
                              : header.textAlign === "right"
                                ? "justify-end"
                                : "justify-center"
                              }`}
                          >
                            {RenderCell({ header, row })}
                          </div>
                        </td>
                      ))}
                    </tr>
                    {orderflow && (
                      <tr className="border-b-[1px] border-baseColor-primary/50 group-hover:border-transparent">
                        <td
                          colSpan={
                            headers.length +
                            (hasMultiEdit || hasMultiDelete ? 1 : 0) +
                            (dateShow ? 1 : 0)
                          }
                          className="bg-white px-0"
                        >
                          {orderflow === "PR" && (
                            <OrderFlow2 yprno={row.ref} value={row.tracker} />
                          )}
                          {orderflow === "PO" && (
                            <OrderFlowPO value={row.tracker} />
                          )}
                          {orderflow === "Shipment" && (
                            <OrderFlowShipment value={row.tracker} createdAt={row.createdAt} />
                          )}
                        </td>
                      </tr>
                    )}
                  </tbody>
                );
              })
            ) : (
              <tbody>
                <tr>
                  <td
                    colSpan={
                      headers.length +
                      (hasMultiEdit || hasMultiDelete ? 1 : 0) +
                      (dateShow ? 1 : 0)
                    }
                  >
                    <div className=" w-full h-[50vh] flex justify-center items-center">
                      <div className=" flex flex-col justify-center items-center">
                        <FileIcon />
                        <p className=" font-medium text-sm 2xl:text-base text-baseColor-secondary my-2">
                          No Data found
                        </p>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            )}
          </table>
        </div>
      </div>
      {/* {DateNewShow && (
        <OrderFlow2 yprno={yprno} value={value} closedate={closedate} />
      )} */}
    </div>
  );
};

// Example usage
const CustomDataTable = ({
  fetcher,
  data,
  availableHeaders,
  defaultHeader,
  total,
  pageIndex,
  setPageIndex,
  dataCount,
  setDataCount,
  height = "h-[calc(100vh-145px)]",
  bodyHeight = "max-h-[calc(100vh-280px)]",
  title = "",
  storageName = "",
  hasMultiEdit = false,
  hasMultiDelete = false,
  selectMultipleFunction = () => { },
  selectOneFunction = () => { },
  listofNumbers = [],
  setShowEdit = () => { },
  showEdit = false,
  setShowDelete = () => { },
  showDelete = false,
  fullList = [],
  getById = "",
  showFieldFalse,
  editAccess = "",
  deteleAccess = "",
  dataLoading = false,
  searchQuery = "",
  dateShow = false,
  orderflow,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t, i18n } = useTranslation();

  // Retrieve headers from local storage or set default headers
  const storedHeaders = JSON.parse(localStorage.getItem(storageName));
  const defaultHeaders = storedHeaders || defaultHeader || availableHeaders;

  // State to track table headers and remaining headers
  const [headersState, setHeadersState] = useState(defaultHeaders);

  useEffect(() => {
    localStorage.setItem(storageName, JSON.stringify(headersState));
  }, [headersState]);

  const toggleHeader = (header) => {
    if (headersState.some((h) => h.field === header.field)) {
      // Remove the header from headersState
      setHeadersState((prevHeaders) =>
        prevHeaders.filter((h) => h.field !== header.field),
      );
    } else {
      // Find the index of the toggled header in availableHeaders
      const headerIndex = availableHeaders.findIndex(
        (h) => h.field === header.field,
      );
      // Insert the header into headersState at the same index
      setHeadersState((prevHeaders) => [
        ...prevHeaders.slice(0, headerIndex),
        header,
        ...prevHeaders.slice(headerIndex),
      ]);
    }
  };

  return (
    <div
      className={`w-full ${height} rounded-md bg-white py-3 pr-3 mt-4 relative`}
    >
      <div className=" flex justify-between items-center ">
        {/* <TextMediumSM content={title} color="text-[#4F4768]"/>  */}
        <p className="font-medium text-xs 2xl:text-sm text-[#4F4768]">
          {title} {data.length > 0 && `: ${total}`}
        </p>
        <div className=" flex gap-3 items-center">
          {hasMultiEdit && listofNumbers.length > 0 && (
            <button
              className=" bg-[#048178] px-3 py-[3px] text-white text-xs font-medium rounded-md "
              onClick={() => setShowEdit(!showEdit)}
            >
              {title === "Supplier" ? "Edit Access" : "Multi Edit"}
            </button>
          )}
          {hasMultiDelete && listofNumbers.length > 0 && (
            <button
              className=" bg-[#048178] px-3 py-[3px] text-white text-xs font-medium rounded-md "
              onClick={() => setShowDelete(!showDelete)}
            >
              Delete
            </button>
          )}
        </div>
        {showFieldFalse == false ? null : (
          <>
            {GetRole() && (
              <div
                className=" rounded-lg  bg-slate-300  px-3 py-1 text-xs  cursor-pointer text-[#4F4768]"
                onClick={() => setIsModalOpen(true)}
              >
                {t("Show Feilds")}
              </div>
            )}
          </>
        )}
      </div>

      <DynamicTable
        fetcher={fetcher}
        data={data}
        headers={headersState}
        bodyHeight={bodyHeight}
        hasMultiEdit={hasMultiEdit}
        hasMultiDelete={hasMultiDelete}
        listofNumbers={listofNumbers}
        selectOne={selectOneFunction}
        selectMultiple={selectMultipleFunction}
        fullList={fullList}
        getById={getById}
        EditAccess={editAccess}
        DeteleAccess={deteleAccess}
        dataLoading={dataLoading}
        total={total}
        pageIndex={pageIndex}
        searchQuery={searchQuery}
        dateShow={dateShow}
        orderflow={orderflow}
      />
      <div className=" w-full h-[40px] text-[#4f4768]">
        <Pagination
          total={total}
          pageIndex={pageIndex}
          setPageIndex={setPageIndex}
          dataCount={dataCount}
          setDataCount={setDataCount}
        />
      </div>
      <ModalContainer
        visiable={isModalOpen}
        title="Table Headers"
        content={
          <div>
            {availableHeaders.map((header, index) => (
              <div
                key={index}
                className=" flex justify-start items-center gap-3 py-1"
                dir={i18n.language == "ar" ? "rtl" : ""}
              >
                <input
                  type="checkbox"
                  id={`header-${index}`}
                  checked={headersState.some((h) => h.field === header.field)}
                  onChange={() => toggleHeader(header)}
                />

                <label className=" font-medium" htmlFor={`header-${index}`}>
                  {t(header.title)}
                </label>
              </div>
            ))}
          </div>
        }
        handleClick={() => setIsModalOpen(false)}
        closeModal={() => setIsModalOpen(false)}
      />
    </div>
  );
};

export default CustomDataTable;